import { LuCheck } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useDropOffConfirmed from './drop-off-confirmed.controller';

const ID = 'drop-off-confirmed';

const DropOffConfirmed = () => {
    const viewProps = useDropOffConfirmed();

    return (
        <WizardScreenContainer
            id={ID}
            footer={{
                onSubmit: viewProps.onContinue
            }}>
            <div className='flex h-full flex-col items-center justify-center gap-4 text-center'>
                <div className='bg-status-success relative flex size-24 items-center justify-center rounded-full'>
                    <LuCheck className='text-always-white size-16' />
                </div>

                <div className='text-foreground-default text-xl font-semibold'>
                    <FormattedMessage
                        id='kiosk.wizard.drop-off-confirmed.title'
                        defaultMessage='Drop-off confirmed'
                        description='Title shown when the kiosk drop-off flow has been completed'
                    />
                </div>
            </div>
        </WizardScreenContainer>
    );
};

export default DropOffConfirmed;
